import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../../services/auth/auth.service";
import { LoginCredentialsDto } from "../../../models/auth/auth.model";
import * as CryptoJS from "crypto-js";

interface UserData {
	name: string;
	password: string;
	saveEnable: boolean;
}

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
	form!: FormGroup;
	isVisible = false;
	inputPasswordType = "password";
	saveUser = false;

	userData!: UserData;
	isFormSending = false;

	secretKey =
		"PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDQwMzYiPgo8cGF0aCBpZD0iSWNvbiIgZD0iTTE0LjQ1OTEgNS4xNDA0MUw4LjEyODU1IDExLjY2NDlDNy42NTk3NyAxMi4xNDgyIDYuODk5MzQgMTIuMTQ4MiA2LjQzMDExIDExLjY2NDlMMy4xNjIyNyA4LjI5NjQzQzIuNjkzMzEgNy44MTMxNiAyLjY5MzMxIDcuMDI5MjcgMy4xNjIyNyA2LjU0NTkxQzMuNjMxMzEgNi4wNjI0NSA0LjM5MTY5IDYuMDYyNDUgNC44NjA1MyA2LjU0NTcyTDcuMjc5NTggOS4wMzkxMUwxMi43NjA1IDMuMzg5OEMxMy4yMjk2IDIuOTA2MzQgMTMuOTkgMi45MDY3MSAxNC40NTg5IDMuMzg5OEMxNC45Mjc3IDMuODczMTYgMTQuOTI3NyA0LjY1Njc3IDE0LjQ1OTEgNS4xNDA0MVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9zdmc+";

	constructor(
		private router: Router,
		private authService: AuthService
	) {}

	ngOnInit() {
		this.initForm();
		if (!!localStorage.getItem("auth-token")) {
			this.router.navigate(["/profile"]);
		}
	}

	initForm(): void {
		this.form = new FormGroup({
			emailFormControl: new FormControl("", [Validators.required, Validators.email]),
			passwordFormControl: new FormControl("", [Validators.required]),
		});

		if (localStorage.getItem("userData")) {
			const decryptData: any = CryptoJS.AES.decrypt(localStorage.getItem("userData") ?? "", this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
			this.userData = { ...JSON.parse(decryptData) };
			this.form.get("emailFormControl")?.setValue(this.userData.name);
			this.form.get("passwordFormControl")?.setValue(this.userData.password);
			this.saveUser = this.userData.saveEnable;
		}
	}

	get emailFormatError() {
		return this.form.get("emailFormControl")?.hasError("email");
	}

	get emailRequiredError() {
		return this.form.get("emailFormControl")?.hasError("required");
	}

	get passwordRequiredError() {
		return this.form.get("passwordFormControl")?.hasError("required");
	}

	visibilityPassword() {
		if (!this.isVisible) {
			this.inputPasswordType = "text";
			this.isVisible = true;
		} else {
			this.inputPasswordType = "password";
			this.isVisible = false;
		}
	}

	sendForm() {
		this.isFormSending = true;
		if (this.saveUser) {
			this.userData = {
				name: this.form.get("emailFormControl")?.value,
				password: this.form.get("passwordFormControl")?.value,
				saveEnable: this.saveUser,
			};
			const encryptData = CryptoJS.AES.encrypt(JSON.stringify(this.userData), this.secretKey.trim()).toString();
			localStorage.setItem("userData", encryptData);
		} else {
			localStorage.removeItem("userData");
		}

		const loginData: LoginCredentialsDto = {
			login: this.form.get("emailFormControl")?.value,
			password: this.form.get("passwordFormControl")?.value,
		};

		this.authService.login(loginData).subscribe({
			next: (res) => {
				if (res.is_first_auth) {
					this.router.navigate(["/profile"], {
						queryParams: { "new-password": true },
					});
				}
			},
			error: (err) => {
				this.isFormSending = false;
			},
			complete: () => {
				this.isFormSending = false;
			},
		});
	}
}
